import React from 'react';

const GraphicTravel = () => {
  return (
    <svg
      width="130"
      height="134"
      viewBox="0 0 130 134"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_693_23579)">
        <path
          d="M32.451 62.2343C32.9752 58.1115 40.6263 50.2385 46.9442 47.1385C53.7651 43.7727 58.1455 43.1384 67.8844 44.173C67.5818 43.6559 67.2894 43.2596 67.0904 42.8622C66.8444 42.4188 66.5889 41.9477 66.4548 41.466C66.4071 41.3271 66.5732 40.9907 66.7315 40.9053C66.8899 40.8199 67.2364 40.9182 67.3401 41.0379C68.3014 42.1982 69.2067 43.3776 70.1495 44.5752C70.442 44.9716 70.3885 45.3625 69.9604 45.6647C68.2941 46.7334 66.6373 47.8299 64.9335 48.8804C64.5423 49.1078 64.0005 49.1696 63.4409 49.3617C63.4786 48.0137 64.5337 47.8068 65.1564 47.2516C65.7975 46.659 66.5422 46.186 67.4072 45.5165C64.5508 44.7584 61.8666 44.5932 59.1664 44.837C49.2624 45.6908 41.5159 50.4609 35.4998 58.1763C34.7212 59.1887 34.0647 60.2833 33.3237 61.3139C33.0635 61.5584 32.8314 61.7933 32.451 62.2343Z"
          fill="#0EA8FF"
        />
      </g>
      <g clip-path="url(#clip1_693_23579)">
        <path
          d="M85.6038 32.6613C86.0013 32.1053 86.3194 31.4701 86.7697 30.9669C91.0868 26.2798 95.9587 22.3064 101.702 19.5226C103.529 18.6477 105.487 17.9577 107.445 17.4795C109.536 16.9217 111.705 16.9194 113.264 18.7432C114.823 20.5669 114.292 22.6838 113.575 24.7216C112.699 27.1829 111.242 29.3273 109.679 31.3659C109.335 31.816 108.964 32.2926 108.778 33.0071C110.075 32.556 111.345 32.1314 112.721 31.6537C112.879 32.6588 112.244 32.977 111.82 33.242C109.411 34.6996 106.976 36.1307 104.514 37.4825C103.429 38.0921 102.662 37.5374 102.822 36.3732C103.248 33.6743 104.362 31.2393 106.004 29.0154C106.057 28.9624 106.216 28.9622 106.428 28.9091C107.432 30.072 105.87 31.0525 106.133 32.375C108.702 29.4358 110.954 26.5498 112.016 22.8979C112.149 22.448 112.202 21.9718 112.203 21.4956C112.204 20.1728 111.623 19.3798 110.3 19.3812C108.819 19.3828 107.284 19.5431 105.882 19.9415C102.547 20.8974 99.5298 22.5408 96.75 24.5278C93.6524 26.7798 90.7133 29.2432 87.6949 31.6273C87.1653 32.0512 86.6357 32.5279 86.0797 32.9782C85.9475 32.899 85.7889 32.7934 85.6038 32.6613Z"
          fill="#0EA8FF"
        />
      </g>
      <path
        d="M7.68053 68.4806C7.77791 67.6251 8.31718 66.8836 9.10099 66.5273L37.9788 53.401L32.4378 114.846L4.70935 127.291C2.97714 128.069 1.05713 126.666 1.27187 124.779L7.68053 68.4806Z"
        fill="#F4F6F9"
        stroke="white"
        strokeWidth="0.7"
      />
      <path
        d="M122.319 68.4806C122.222 67.6251 121.683 66.8836 120.899 66.5273L92.0212 53.401L97.5622 114.846L125.291 127.291C127.023 128.069 128.943 126.666 128.728 124.779L122.319 68.4806Z"
        fill="#F4F6F9"
        stroke="white"
        strokeWidth="0.7"
      />
      <path
        d="M65.2449 132.668L65.2449 59.9468L91.3079 53.2744L96.9688 114.955L65.2449 132.668Z"
        fill="#F4F6F9"
        stroke="white"
        strokeWidth="0.7"
      />
      <path
        d="M64.5446 132.668L64.5447 59.9468L38.4816 53.2744L32.8208 114.955L64.5446 132.668Z"
        fill="#F4F6F9"
        stroke="white"
        strokeWidth="0.7"
      />
      <path
        d="M92.4706 28.8488C92.4706 52.5608 64.4406 78.4371 64.4406 78.4371C64.4406 78.4371 36.4106 52.5608 36.4106 28.8488C36.4106 21.4148 39.3638 14.2853 44.6204 9.02864C49.8771 3.772 57.0066 0.818848 64.4406 0.818848C71.8746 0.818848 79.0042 3.772 84.2608 9.02864C89.5175 14.2853 92.4706 21.4148 92.4706 28.8488Z"
        fill="#D0D9E3"
      />
      <path
        d="M89.2455 43.8926C81.8825 62.3529 64.4407 78.4367 64.4407 78.4367C64.4407 78.4367 46.9989 62.3529 39.636 43.8926C43.9787 50.8662 49.0967 57.326 54.8923 63.1486C56.1369 64.4189 57.6226 65.4281 59.2621 66.1171C60.9017 66.806 62.6623 67.1609 64.4407 67.1609C66.2192 67.1609 67.9797 66.806 69.6193 66.1171C71.2589 65.4281 72.7445 64.4189 73.9892 63.1486C79.7847 57.326 84.9027 50.8662 89.2455 43.8926Z"
        fill="#9FA8B3"
      />
      <path
        d="M64.4406 41.7817C71.5833 41.7817 77.3735 35.9915 77.3735 28.8489C77.3735 21.7062 71.5833 15.916 64.4406 15.916C57.298 15.916 51.5078 21.7062 51.5078 28.8489C51.5078 35.9915 57.298 41.7817 64.4406 41.7817Z"
        fill="white"
      />
      <path
        d="M77.1719 30.971C76.6506 27.9726 75.0878 25.2544 72.7588 23.2953C70.4298 21.3363 67.484 20.2621 64.4406 20.2621C61.3973 20.2621 58.4515 21.3363 56.1225 23.2953C53.7935 25.2544 52.2307 27.9726 51.7094 30.971C51.3768 29.1095 51.4565 27.1977 51.9428 25.3704C52.4292 23.543 53.3103 21.8446 54.5241 20.3946C55.738 18.9447 57.255 17.7786 58.9684 16.9785C60.6817 16.1783 62.5497 15.7637 64.4406 15.7637C66.3316 15.7637 68.1996 16.1783 69.9129 16.9785C71.6263 17.7786 73.1433 18.9447 74.3572 20.3946C75.571 21.8446 76.4521 23.543 76.9385 25.3704C77.4248 27.1977 77.5045 29.1095 77.1719 30.971Z"
        fill="#E9ECF0"
      />
      <defs>
        <clipPath id="clip0_693_23579">
          <rect
            width="41.44"
            height="9.94001"
            fill="white"
            transform="translate(29.2241 52.8335) rotate(-18.9449)"
          />
        </clipPath>
        <clipPath id="clip1_693_23579">
          <rect
            width="19.4924"
            height="29.4158"
            fill="white"
            transform="translate(106.1 11.5576) rotate(45)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default GraphicTravel;
